import React, {useEffect, useRef, useState} from "react";

import AuctionTimer from '../../../utils/auctionTimer'

export default function TopCardAuctionSummaryComponent(props){
    const [time, setTime] = useState(false);
    const [at, setAt] = useState({});
    
    useEffect(()=>{
        let att = new AuctionTimer(props.item)
        setAt(att);
        if(att.shouldTimerChange()){
            console.log('start timer')
            att.startTimer((ttime, seconds)=>{
                setTime(ttime)
            })
        }
        return()=>{ att.destoryTimer()}
    },[]);
    
    return (
        <div style={{
            paddingLeft: 0, display: 'flex',
            justifyContent: 'space-between',
            padding: '7.5px 0px',
            }}>
            <div style={{display: 'flex',
                         flexDirection: 'column',
                         justifyContent: 'center',
                         alignItems: 'flex-start'}}>
                <span style={{fontSize: 10, opacity: 0.4}}>Top Bid</span>
                {props.item.highestMintBid && (
                    <span style={{fontSize: 12,
                                  fontWeight: 400}}>
                        {props.item.highestMintBid} {props.item.highestMintBidCurrency}</span>)}
            </div>
            <div style={{display: 'flex', flexDirection: 'column',
                         justifyContent: 'center',
                         alignItems: 'flex-end', marginLeft: 20}}>

                {(time!=false) && (
                    <>
                        <span style={{fontSize: 10, opacity: 0.4}}>Auction Ends In</span>
                        <span style={{fontSize: 12, fontWeight: 400}}>{time.h}h {time.m}m {time.s}s</span>
                    </>
                )}
            </div>
        </div>
    )
}
